<template>
  <div class="addSupplementaryInfo">
    <el-dialog :visible.sync="show" title="补充资料" :top="'5vh'" :before-close="handleClose" class="boder8 resetRegister" :close-on-click-modal="false">
      <el-alert class="infoIcon" title="您的资料请务必如实准确填写，因个人信息错误导致的一切后果由本人自行承担" :closable="false" show-icon></el-alert>
      <div class="pay-mains">
        <el-form ref="form" :model="form" class="demo-ruleForm" label-width="260px" label-position="left" >
          <el-row>
            <el-col :span="12">
              <el-form-item
                class="el-form-item-update"
                ref="politicalAffiliation"
                label="政治面貌："
                prop="politicalAffiliation"
              >
                <el-select v-model="form.politicalAffiliation" :disabled="disabled">
                  <el-option v-for="it in politicalAffiliationOption" :key="it.id" :value="it.id" :label="it.name"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                class="el-form-item-update"
                ref="maritalStatus"
                label="婚姻状况："
                prop="maritalStatus"
              >
                <el-select v-model="form.maritalStatus" placeholder="请选择" :disabled="disabled">
                  <el-option label="已婚" value="married"></el-option>
                  <el-option label="未婚" value="unmarried"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                class="el-form-item-update"
                ref="idCardAddress"
                label="身份证住址："
                prop="idCardAddress"
              >
                <el-input v-model="form.idCardAddress" placeholder="请输入" maxlength="50" :disabled="disabled"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                class="el-form-item-update"
                ref="accommodationType"
                label="住宿方式："
                prop="accommodationType"
              >
                <el-select v-model="form.accommodationType" placeholder="请选择" :disabled="disabled">
                  <el-option label="宿舍" value="inHostel"></el-option>
                  <el-option label="外宿" value="outHouse"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                class="el-form-item-update"
                ref="height"
                label="身高："
                prop="height"
              >
                <el-input v-model="form.height" placeholder="请输入" maxlength="3" :disabled="disabled">
                  <template slot="append">CM</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                class="el-form-item-update"
                ref="weight"
                label="体重："
                prop="weight"
              >
                <el-input v-model="form.weight" placeholder="请输入" maxlength="3" :disabled="disabled">
                  <template slot="append">KG</template>
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
            <el-row>
              
              <el-col :span="12">
                <el-form-item
                  class="el-form-item-update"
                  ref="degreeOfEducation"
                  label="文化程度（学历）："
                  prop="degreeOfEducation"
                >
                  <el-select v-model="form.degreeOfEducation" placeholder="请选择" :disabled="disabled">
                    <el-option v-for="it in degreeOfEducationOption" :key="it.id" :value="it.id" :label="it.name"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item
                  class="el-form-item-update"
                  ref="graduatedSchool"
                  label="毕业院校："
                  prop="graduatedSchool"
                >
                  <el-input v-model="form.graduatedSchool" placeholder="请输入" maxlength="30" :disabled="disabled"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
            
            <el-col :span="12">
              <el-form-item
                class="el-form-item-update"
                ref="professional"
                label="专业："
                prop="professional"
              >
                <el-input v-model="form.professional" placeholder="请输入" maxlength="20" :disabled="disabled"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item
                class="el-form-item-update"
                ref="healthCertificateImgUrl"
                label="健康证上传（1张）："
                prop="healthCertificateImgUrl"
              >

                <div v-if="disabled">
                  <el-image
                    class="img"
                    :src="form.healthCertificateImgUrl"
                    :preview-src-list="[form.healthCertificateImgUrl]"
                  ></el-image>
                </div>
                <template v-else><sing-upload @file="getHealthCertificateImgUrl" :fileList="form.healthCertificateImgUrl" @delete="handleHandImgUrl" module="healthCertificate"></sing-upload></template>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                class="el-form-item-update"
                ref="healthCertificateHandleTime"
                label="健康证办理时间："
                prop="healthCertificateHandleTime"
              >
                <el-date-picker v-model="form.healthCertificateHandleTime" value-format="yyyy-MM-dd" :disabled="disabled" type="date" placeholder="选择日期" :picker-options="beginPickerOptions"></el-date-picker>
              </el-form-item>
            </el-col>
            
            <el-col :span="24">
              <el-form-item
                class="el-form-item-update"
                ref="healthImgUrlList"
                label="体检报告上传（最多12张）："
                prop="healthImgUrlList"
              >
                <div v-if="disabled">
                  <el-image
                    class="img"
                    v-for="(item,index) in form.healthImgUrlList"
                    :src="item"
                    :key="index"
                    :preview-src-list="previewList"
                    @click="handPreview(item)"
                  ></el-image>
                </div>
                <template v-else> 
                  <imgUpload @file="getHealthImgFile" :limit="12" :fileList="form.healthImgUrlList" @delete="deleteImgFile" module="healthReport"
                  ></imgUpload>
                </template>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item
                class="el-form-item-update"
                ref="healthTime"
                label="体检时间："
                prop="healthTime"
              >
                <el-date-picker v-model="form.healthTime" value-format="yyyy-MM-dd" :disabled="disabled" type="date" placeholder="选择日期" :picker-options="beginPickerOptions"></el-date-picker>
              </el-form-item>
            </el-col>
            
          </el-row>
          
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer" v-if="!disabled">
        <div class="btns">
          <el-button @click="handleClose">取消</el-button>
          <el-button type="primary" @click="confirm">确定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import singUpload from "../../../components/common/modules/singleUpload.vue";
import imgUpload from "../../../components/common/modules/upload";
export default {
  data () {
    return {
      show: false,
      politicalAffiliationOption: [
        { id: 'crowd', name: '群众' },
        { id: 'partyMember', name: '中共党员' },
        { id: 'preparePartyMember', name: '中共预备党员' },
        { id: 'youthMember', name: '共青团员' },
        { id: 'member', name: '民主党派成员' },
        { id: 'noMember', name: '无党派人士' }
      ],
      degreeOfEducationOption: [
        { id: 'primary', name: '小学' },
        { id: 'middle', name: '中学' },
        { id: 'high', name: '高中' },
        { id: 'vocationalHigh', name: '职高' },
        { id: 'secondarySpecialized', name: '中专' },
        { id: 'juniorCollege', name: '大专' },
        { id: 'undergraduate', name: '本科' },
        { id: 'postgraduate', name: '研究生' },
      ],
      form: {
        politicalAffiliation: "",
        politicalAffiliationCn: "",
        maritalStatus: "",
        idCardAddress: "",
        height: "",
        weight: "",
        degreeOfEducation: "",
        degreeOfEducationCn: "",
        graduatedSchool: "",
        professional: "",
        healthCertificateHandleTime: "",
        healthTime: "",
        healthCertificateImgUrl: "",
        accommodationType: '',
        healthImgUrlList: []
      },
      disabled: false,
      previewList: []
    }
  },
  computed: {
    beginPickerOptions() {
      return {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      };
    },
  },
  components: { 
    imgUpload,
    singUpload
  },
  methods: {
    open (arg) {
      this.form = JSON.parse(JSON.stringify(arg))
      if (arg.isDetail) {
        this.disabled = arg.isDetail
      } else {
        this.disabled = false
      }
      this.show = true
    },
    getHealthCertificateImgUrl (res) {
      console.log(res); 
      this.form.healthCertificateImgUrl = res
    },
    getHealthImgFile (res) { 
      this.form.healthImgUrlList.push(res)
    },
    handleHandImgUrl () {
      this.form.healthCertificateImgUrl = ''
    },
    deleteImgFile (val) {  
      this.form.healthImgUrlList = val.myFileList
    },
    handPreview (url) {
      let imgUrl = []
      this.previewList = []
      if (url.indexOf("?") > -1) {
        let arr = url.split("?")
        imgUrl.push(arr[0])
      } else {
        imgUrl.push(url)
      }
      this.previewList = imgUrl
      console.log(this.previewList);
    },
    confirm () {
      if (!this.form.politicalAffiliation) {
        return this.$message.error('请选择政治面貌')
      } else if (!this.form.maritalStatus) {
        return this.$message.error('请选择婚姻状况')
      } else if (!this.form.idCardAddress) {
        return this.$message.error('请输入身份证地址')
      } else if (!this.form.accommodationType) {
        return this.$message.error('请选择住宿方式')
      } else if (this.form.height && !/^[1-9]\d*$/.test(this.form.height)) {
        return this.$message.error("身高必须为正整数并且大于0");
      } else if (this.form.weight && !/^[1-9]\d*$/.test(this.form.weight)) {
        return this.$message.error("体重必须为正整数并且大于0");
      } else if (!this.form.degreeOfEducation) {
        return this.$message.error('请选择文化程度')
      } else if (!this.form.graduatedSchool) {
        return this.$message.error('请输入毕业院校')
      } else if ((this.form.healthCertificateImgUrl && !this.form.healthCertificateHandleTime) || (!this.form.healthCertificateImgUrl && this.form.healthCertificateHandleTime)) {
        return this.$message.error("请同时填写健康证办理时间和上传健康证");
      } else if ((this.form.healthImgUrlList && this.form.healthImgUrlList.length > 0 && !this.form.healthTime) || (this.form.healthImgUrlList.length == 0 && this.form.healthTime)) {
        return this.$message.error("请同时填写体检时间和上传体检报告");
      }

      this.$emit('change', { 
        politicalAffiliation: this.form.politicalAffiliation,
        accommodationType: this.form.accommodationType,
        // politicalAffiliationCn: "",
        maritalStatus: this.form.maritalStatus,
        idCardAddress: this.form.idCardAddress,
        height: this.form.height,
        weight: this.form.weight,
        degreeOfEducation: this.form.degreeOfEducation,
        // degreeOfEducationCn: "",
        graduatedSchool: this.form.graduatedSchool,
        professional: this.form.professional,
        healthCertificateHandleTime: this.form.healthCertificateHandleTime,
        healthTime: this.form.healthTime,
        healthCertificateImgUrl: this.form.healthCertificateImgUrl,
        healthImgUrlList: this.form.healthImgUrlList
      })
      this.show = false
    },
    handleClose () {
      this.show = false
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/css/edit.less";
.resetRegister .resetRegister-box {
  box-sizing: border-box;
}
.img {
  width: 80px;
  height: 80px;
  margin-right: 10px;
}
.infoIcon {
  color: #155BD4 !important;
  border: 1px solid #94B4EB !important;
  background-color: #EDF4FF !important;
}
.addSupplementaryInfo {
  .el-date-editor {
    width: 100% !important;
  }
  .el-select {
    width: 100%;
  }
}

</style>